const getLabels = (options: { label: string }[]) =>
  options.map((option) => option.label);

export default getLabels;
